import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';
import Link from '@/components/Link';
import { getPhoneLink } from '@/utils/common';

interface Props {
  name: string;
  phones: string[];
  workTime: string[];
}

function Service({ name, phones, workTime }: Props) {
  return (
    <Component>
      <Name>{name}</Name>
      {phones && phones.length !== 0 && (
        <Item>
          <Title>Телефоны</Title>
          {phones.map((phone, index) => (
            <PhoneLink key={index} to={getPhoneLink(phone)}>
              {phone}
            </PhoneLink>
          ))}
        </Item>
      )}

      {workTime && workTime.length !== 0 && (
        <Item>
          <Title>Время работы</Title>
          {workTime.map((time, index) => (
            <ItemText key={index}>{time}</ItemText>
          ))}
        </Item>
      )}
    </Component>
  );
}

export default Service;

const Component = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-direction: column;

  ${media.tablet(css`
    padding: 20px;
  `)}

  ${media.mobile(css`
    padding: 10px 20px;
  `)}
`;

const Name = styled.p`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${(props) => props.theme.black};

  ${media.tabletSmall(css`
    font-size: 20px;
    line-height: 30px;
  `)}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.black};

  ${media.tabletSmall(css`
    font-size: 14px;
    line-height: 20px;
  `)}
`;

const ItemText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.blue100};
`;

const PhoneLink = styled(Link)`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.main};
`;
